import ServiceGraphQL from 'src/service/gql-service';

const serviceGraphQL = new ServiceGraphQL();

export const ApplyGlobalPay = (data) => {
  const params = {
    query: `
      mutation {
        applyGlobalPay {
          status
          errors {
            field
            reasons
          }
        }
      }`,
    variables: {
      ...data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
